const data = [
  { id: 0, name: "Pendente" },
  { id: 1, name: "Aprovado" },
  { id: 2, name: "Rejeitado" },
  { id: 3, name: "Aprovado Parcial" },
];

export default [...data];
